import { OrderAPI } from '@business/api/order';
import { OrderActivityResponse } from '@business/entities/order';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { R } from '@core/utils/r';
import { Repository } from '@core/utils/repository';
import { pipeIf } from '@core/utils/rxjs/operators';
import { map } from 'rxjs/operators';
import { OrderActivityPageQuery } from './../../entities/order/OrderActivityResponse';

export class OrderActivityBloc extends BaseBloc {
  private readonly activityRepo = new Repository<OrderActivityResponse>({
    getItemId: activity => activity.id,
    pagenated: true,
  });

  readonly activities$ = this.activityRepo.items$.pipe(map(items => R.sortBy(items, item => -item.createdAt)));

  onReset() {
    this.activityRepo.reset();
  }

  fetchPaginateActivities = (options: OrderActivityPageQuery) => {
    return OrderAPI.fetchPaginateActivities(options);
  };

  fetchActivities = (options: OrderActivityPageQuery) => {
    if (options.page === 1) {
      this.activityRepo.ops.reset();
    }
    return OrderAPI.fetchActivities(options).pipe(
      pipeIf((options.page === 1 || options.page === undefined) && this.activityRepo.ops.reset()),
      pipeIf(options.page !== undefined && options.page > 1 && this.activityRepo.ops.upsertMany(item => ({ item }))),
      //   this.activityRepo.ops.upsertMany(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_activities_error') }),
    );
  };
}
